/**
 * @deprecated 不要在这里维护账号类型，应该使用后台协议中定义的枚举值
 * import type { docx } from '@tencent/tdocs-shared-proto/lib/3rd/oidb/user/data/online_docs_user_data';
 * export type ACCOUNT_TYPE = docx.backend.common.proto.third.oidb.user.data.UID_SOURCE;
 * 登录类型
 */
export var ACCOUNT_TYPE;
(function (ACCOUNT_TYPE) {
    ACCOUNT_TYPE[ACCOUNT_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
    ACCOUNT_TYPE[ACCOUNT_TYPE["QQ"] = 1] = "QQ";
    ACCOUNT_TYPE[ACCOUNT_TYPE["WX"] = 2] = "WX";
    ACCOUNT_TYPE[ACCOUNT_TYPE["WORK"] = 3] = "WORK";
    ACCOUNT_TYPE[ACCOUNT_TYPE["EMAIL"] = 4] = "EMAIL";
    ACCOUNT_TYPE[ACCOUNT_TYPE["PHONE"] = 8] = "PHONE";
    ACCOUNT_TYPE[ACCOUNT_TYPE["WORK_COMBINATION"] = 9] = "WORK_COMBINATION";
    ACCOUNT_TYPE[ACCOUNT_TYPE["TOWER"] = 10] = "TOWER";
    ACCOUNT_TYPE[ACCOUNT_TYPE["ROBOT"] = 11] = "ROBOT";
    ACCOUNT_TYPE[ACCOUNT_TYPE["QFYF"] = 12] = "QFYF";
    ACCOUNT_TYPE[ACCOUNT_TYPE["OPEN"] = 13] = "OPEN";
    ACCOUNT_TYPE[ACCOUNT_TYPE["MEETING"] = 14] = "MEETING";
})(ACCOUNT_TYPE || (ACCOUNT_TYPE = {}));
// b端登录类型
export var LOGINTYPE;
(function (LOGINTYPE) {
    LOGINTYPE[LOGINTYPE["UNKNOWN"] = 0] = "UNKNOWN";
    /**
     * 微信登录
     **/
    LOGINTYPE[LOGINTYPE["WECHAT"] = 4] = "WECHAT";
    /**
     * 企业微信登录
     **/
    LOGINTYPE[LOGINTYPE["WEWORK"] = 3] = "WEWORK";
})(LOGINTYPE || (LOGINTYPE = {}));
